import { getLocalAssetUrl } from 'core/utilities';

export const imgBackup = {
  BOTICARIO: getLocalAssetUrl('/images/mld-boticario.png'),
  EUAMOMAKE: getLocalAssetUrl('/images/mld-euamomake.png'),
  OUI: getLocalAssetUrl('/images/mld-oui.png'),
  EUDORA: getLocalAssetUrl('/images/mld-eudora.png'),
  MULTIMARCA: getLocalAssetUrl('/images/mld-multimarca.png'),
};
